// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import polyfill from 'babel-polyfill'
import Vue from 'vue'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import App from './App'
import axios from 'axios'
import request from '@/common/request.js'
import * as tools from '@/common/validate'
import * as common from '@/common/common'
import router from './router'
import vfooter from './components/footer/footer'
import vheader from './components/header/header'
import VueCookies from 'vue-cookies'
import './assets/icon-font/iconfont.css'

request.init();
Vue.use(polyfill);
Vue.use(vfooter);
Vue.use(vheader);
Vue.use(ElementUI);
Vue.use(VueCookies);

Vue.prototype.$tools = tools;
Vue.prototype.$common = common;

Vue.prototype.$axios = axios;

Vue.config.productionTip = false


/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  components: {App},
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js